// New breakpoints based on the FA designs
export enum ViewportSize {
  xs = 0,
  sm = 640,
  md = 1024,
  lg = 1440,
  xl = 1680,
}

export type BreakpointName = keyof typeof ViewportSize;
